// extracted by mini-css-extract-plugin
export default {"root":"search_root__eg0bU","input":"search_input__-4mbz","icon":"search_icon__RuWw5","clearIcon":"search_clearIcon__BO92k"};